import React, {useEffect, useState} from 'react';
import {BrowserRouter as Router, Route, Routes, useLocation, useNavigate} from 'react-router-dom';
import Switch from 'react-router-dom';
import withRouter from 'react-router-dom';
import AddModal from './components/common/AddModal';
import Sidebar from './components/common/Sidebar';
import AuthIndex from "./screens/AuthIndex";
import MainIndex from './screens/MainIndex';
import Signup from "./components/Auth/Signup";
import SignIn from "./components/Auth/SignIn";
import AuthLeft from "./components/Auth/AuthLeft";
import axios from "axios";
import {setUser} from "./Redux/Actions/userActions";
import {useDispatch} from "react-redux";
import apiClient from "./utils/api";
import 'bootstrap/dist/css/bootstrap.min.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


function App(props) {
    const activekey = () => {
        var res = window.location.pathname
        var baseUrl = process.env.PUBLIC_URL
        baseUrl = baseUrl.split("/");
        res = res.split("/");
        res = res.length > 0 ? res[baseUrl.length] : "/";
        res = res ? "/" + res : "/";
        const activeKey1 = res;
        return activeKey1
    }
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const isPrintRoute = location.pathname.includes('parking-customer-ticket') || 
                        location.pathname.includes('parking-car-ticket') ||
                        location.pathname.includes('parking-key-ticket') ||
                        location.pathname.includes('parking-qr-code');
                        //|| location.pathname.includes('parking-combined-ticket')


    // if (activekey() === '/sign-in' || activekey() === '/sign-up' || activekey() === '/reset-password' || activekey() === '/verification' || activekey() === '/page-404') {
    //   return (
    //       <Routes>
    //         <Route exact path={process.env.PUBLIC_URL+"/sign-in"} element={ <SignIn /> }/>
    //       </Routes>
    //   );
    // }

    useEffect(() => {
        const token = localStorage.getItem('auth_token');
        if (!token) {
            dispatch(setUser(null));
            setLoading(false);
            navigate(process.env.PUBLIC_URL + '/sign-in');
            return;
        }
        const fetchUser = async () => {
            try {
                const response = await apiClient.get('auth/me', {
                    headers: {
                        Authorization: token ? `Bearer ${token}` : '',
                    },
                });
                dispatch(setUser(response.data.data));

                if (location.pathname === process.env.PUBLIC_URL + "/sign-in") {
                    navigate(process.env.PUBLIC_URL + '/accounts/dashboard');
                } else {
                    navigate(location.pathname);
                }

            } catch (error) {
                dispatch(setUser(null));
                navigate(process.env.PUBLIC_URL+'/sign-in');
            } finally {
                setLoading(false);
            }
        };

        fetchUser();
    }, [dispatch]);

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <>
        {location.pathname === process.env.PUBLIC_URL + "/sign-in" && (
            <div className='main p-2 py-3 p-xl-5 '>
                <div className='body d-flex p-0 p-xl-5'>
                    <div className='container-xxl'>
                        <div className='row g-0'>
                            {/*<AuthLeft/> */}
                            <Routes>
                                <Route exact path={process.env.PUBLIC_URL + "/sign-in"} element={<SignIn/>}/>
                            </Routes>
                        </div>
                    </div>
                </div>
          </div>
        )}

        {location.pathname !== process.env.PUBLIC_URL + "/sign-in" && (
            <div id="ebazar-layout" className='theme-blue'>
                {!isPrintRoute && <Sidebar activekey={activekey()} history={props.history}/>}
                {!isPrintRoute && <AddModal/>}
                <MainIndex activekey={activekey()}/>
            </div>
        )}
        <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
         </>
        // <div id="ebazar-layout" className='theme-blue'>
        //     <Sidebar activekey={activekey()} history={props.history}/>
        //     <AddModal/>
        //     <MainIndex activekey={activekey()}/>
        // </div>
    )
}

export default App;